import React from "react";
import { Layout } from "antd";
import { Helmet } from "react-helmet";
import MetaTagContents from "../../MetaTagContents";
import NavBar from "../landingPage/header/navbar";
import Footer from "../landingPage/footer";
import Faqs from "../pricingV2/components/Faqs/Faqs";

const { Content } = Layout;
const { name, content, schemaMarkup } = MetaTagContents.FAQS;

function FAQs() {
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{MetaTagContents.FAQS.title}</title>
        <link rel="canonical" href="https://all3d.ai/faqs" />
        <meta name={name} content={content} />
        <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>

      <NavBar />

      <Layout style={{ marginTop: '100px', background: 'white' }}>
        <Content className="d-none d-xl-block">
          <Faqs title="FAQs" />
        </Content>
        <Content className="d-xl-none">
          <Faqs title="FAQs" />
        </Content>
      </Layout>
      <Footer />
    </React.Fragment>
  );
}

export default FAQs;
